module.exports = __webpack_public_path__ + "b06692fc74d7eb75323564160126a109.svg";